export default __webpack_public_path__ + "static/media/front-sprocket-protector.ae2f102f.glb";